import EA from '../helpers/init';

export default EA.Methods.teamCardsMobileDropdownHandler = ($this) => {
    const teamCards = $this.querySelectorAll('.team-card');

    function checkScreenWidth() {
        teamCards.forEach(card => {
            const cardContentWrapper = card.querySelector('.content-wrapper');
            if(window.innerWidth > 600) {
                cardContentWrapper.classList.add('expanded');
                card.querySelector('.about-outer-wrapper').removeAttribute('inert');
            } else {
                cardContentWrapper.classList.remove('expanded');
                card.querySelector('.about-outer-wrapper').setAttribute('inert', true);
            }
        });
    };

    teamCards.forEach(card => {
        const dropdownToggler = card.querySelector('.mobile-dropdown-toggler');
        const dropdownContentWrapper = card.querySelector('.about-outer-wrapper');

        if(dropdownToggler) {
            dropdownToggler.addEventListener('click', () => {
                const cardContentWrapper = card.querySelector('.content-wrapper');
                if(cardContentWrapper.classList.contains('expanded')) {
                    cardContentWrapper.classList.remove('expanded');
                    dropdownContentWrapper.setAttribute('inert', true);
                } else {
                    cardContentWrapper.classList.add('expanded');
                    dropdownContentWrapper.removeAttribute('inert');
                }
            });
        }
    });

    checkScreenWidth();

    let resizeTimeoutId;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeoutId);
        resizeTimeoutId = setTimeout(checkScreenWidth, 150);
    });
};
